// pages/admin/components/AdminConfirmDialog.js
import React from 'react';
import AdminModal from './AdminModal';

const AdminConfirmDialog = ({
  show,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmClass = 'admin-btn-primary',
  onConfirm,
  onCancel,
  loading = false
}) => {
  const footer = (
    <div className="admin-confirm-dialog-actions">
      <button 
        className="admin-btn admin-btn-secondary"
        onClick={onCancel}
        disabled={loading}
      >
        {cancelText}
      </button>
      <button 
        className={`admin-btn ${confirmClass}`}
        onClick={onConfirm}
        disabled={loading}
      >
        {loading ? (
          <>
            <i className="fas fa-spinner fa-spin"></i>
            Processing...
          </>
        ) : (
          confirmText
        )}
      </button>
    </div>
  );

  return (
    <AdminModal
      show={show}
      onClose={onCancel}
      title={title}
      footer={footer}
      size="small"
    >
      <div className="admin-confirm-dialog">
        <div className="admin-confirm-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <div className="admin-confirm-message">
          <p>{message}</p>
        </div>
      </div>
    </AdminModal>
  );
};

export default AdminConfirmDialog;